/* styles/clearfix */ function _(require, module, exports) {
    require(311) /* ./root */;
    var _a = require(5) /* ../core/dom */;
    _a.styles.append(".bk-root .bk-clearfix:before,\n.bk-root .bk-clearfix:after {\n  content: \"\";\n  display: table;\n}\n.bk-root .bk-clearfix:after {\n  clear: both;\n}\n");
    exports.bk_clearfix = "bk-clearfix";
}
